import {
    ActivatedRouteSnapshot,
    ResolveFn,
    RouterStateSnapshot,
} from '@angular/router';
import { BreadcrumbService } from '../services/breadcrumbs/breadcrumb.service';
import { inject } from '@angular/core';
import { Observable, take } from 'rxjs';
import { SitemapApiService } from '../../libs/api-contract/sitemap/sitemap.service';
import { ClientsService } from '../../core/services/clients/clients.service';

export const breadcrumbResolver =
    (labelProvider?: Observable<string>): ResolveFn<void | Observable<void>> =>
    (
        snapshot: ActivatedRouteSnapshot,
        __: RouterStateSnapshot,
        breadcrumbService = inject(BreadcrumbService),
    ): void | Observable<void> => {
        const routeTree = [snapshot];
        const clientsService = inject(ClientsService);
        const sitemapService = inject(SitemapApiService);
        if (labelProvider) {
            // TODO implement observable path
        }

        while (routeTree[routeTree.length - 1]?.['parent']) {
            routeTree.push(routeTree[routeTree.length - 1]?.['parent'] as any);
        }
        const breadcrumbs = routeTree.filter(
            (breadcrumb) =>
                ![null, undefined].includes(breadcrumb.data?.['breadcrumb']),
        );

        const mappedBreadcrumbs = breadcrumbs
            .map((breadcrumb, i) => {
                const paths = breadcrumbs
                    .slice(i, breadcrumbs.length - 1)
                    .map((bcrumb) => bcrumb.url[0]?.path || '')
                    .reverse();
                const path =
                    paths && paths.length ? '/' + paths.join('/') : '/';

                return {
                    label: breadcrumb.data?.['breadcrumb'],
                    path,
                };
            })
            .reverse();

        sitemapService
            .getSitemap()
            .pipe(take(1))
            .subscribe((sitemap) => {
                if (clientsService.isAdviserImpersonatingClient()) {
                    const clientEntry = sitemap.find(
                        (entry) => entry.code === 'client',
                    );
                    if (clientEntry) {
                        mappedBreadcrumbs.unshift({
                            label: sitemap[0].displayName?.parameters?.['name'],
                            path: '',
                        });
                    }
                }
                breadcrumbService.updateBreadcrumbs(mappedBreadcrumbs);
            });
    };
